import SmoothScroll from "smooth-scroll";
import Swiper from "swiper";
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { domReady } from "./_dom_utils";

function setupSmoothScroll() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).smoothScroll = new SmoothScroll("[data-smooth-scroll]", {
    speed: 500,
    speedAsDuration: true,
    // offset: 60,
    updateURL: false,
  });

}

function setupHero() {
  const heroElement = document.querySelector(".p-home-section-hero");
  if (!heroElement) {
    throw new Error("heroElement is null");
  }
  heroElement.classList.remove("p-home-section-hero--loading");

}

function setupScrollTrigger() {
  const targets = document.querySelectorAll('[data-scroll-trigger]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-is-active');
        // 一度きりでよければ監視解除
        observer.unobserve(entry.target);
      } else {
        // entry.target.classList.remove('js-is-active');
      }
    });
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  });

  targets.forEach((el) => observer.observe(el));


}
function setupInviewToggle() {
  const targets = document.querySelectorAll('[data-inview-toggle]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('js-is-active');
        // // 一度きりでよければ監視解除
        // observer.unobserve(entry.target);
      } else {
        entry.target.classList.remove('js-is-active');
      }
    });
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  });

  targets.forEach((el) => observer.observe(el));

}

function setupSwiper() {
  const swiperElement = document.querySelector<HTMLElement>(".p-home-section-examples__swiper");

  if (!swiperElement) {
    return;
  }

  const swiper = new Swiper(swiperElement, {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".p-home-section-examples__button-next",
      prevEl: ".p-home-section-examples__button-prev",
      addIcons: false,
    },
    pagination: {
      el: ".p-home-section-examples__pagination",
      type: "fraction",
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    });
  }, {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  });

  observer.observe(swiperElement);
}

function setupFloat() {
  const triggerList = document.querySelectorAll<HTMLElement>('[ data-float-trigger]');
  const target = document.querySelector<HTMLElement>('.c-float-go');

  // ない場合もある、その場合は気にしない。
  if (target) {
    const visibleTargets = new Set();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleTargets.add(entry.target);
        } else {
          visibleTargets.delete(entry.target);
        }
      });
      if (visibleTargets.size > 0) {
        target.classList.add('js-is-active');
      } else {
        target.classList.remove('js-is-active');
      }
    }, {
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0,
    });

    triggerList.forEach((trigger) => observer.observe(trigger));
  }

}

function setupMenu() {
  const menuElement = document.querySelector<HTMLElement>(".c-menu");
  if (!menuElement) {
    throw new Error("menuElement is null");
  }


  const menuOpenElement = document.querySelector<HTMLElement>(".c-menu__open");
  if (!menuOpenElement) {
    throw new Error("menuOpenElement is null");
  }
  const menuCloseElement = document.querySelector<HTMLElement>(".c-menu__close");
  if (!menuCloseElement) {
    throw new Error("menuCloseElement is null");
  }
  const navItemElementList = document.querySelectorAll<HTMLElement>(".c-nav__item");

  menuOpenElement.addEventListener("click", () => {
    menuElement.classList.add("js-is-active");
  });
  menuCloseElement.addEventListener("click", () => {
    menuElement.classList.remove("js-is-active");
  })

  navItemElementList.forEach((navItemElement) => {
    navItemElement.addEventListener("click", () => {
      menuElement.classList.remove("js-is-active");
    })
  })

}


domReady(() => {
  setupSmoothScroll();
  setupHero();
  setupSwiper();
  setupMenu();
  setupFloat();
  setupScrollTrigger();
  setupInviewToggle();
});
